"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgBluetooth = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M11.576 1.094a1 1 0 0 1 1.064.138l6 5a1 1 0 0 1 0 1.536L15.722 10.2a1 1 0 0 1-1.28-1.536L16.438 7 13 4.135V7a1 1 0 1 1-2 0V2a1 1 0 0 1 .576-.906Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.7 11.287 3.708 2.293a1 1 0 0 0-1.414 1.414l8.226 8.226-5.16 4.299a1 1 0 1 0 1.281 1.536L11 14.135V22a1 1 0 0 0 1.64.768l4.753-3.96 2.9 2.9a1 1 0 0 0 1.414-1.415l-8.994-8.994a.702.702 0 0 0-.012-.012Zm3.273 6.1L13 19.865v-5.45l2.973 2.972Z", fill: "currentColor" })] }))); };
exports.default = SvgBluetooth;
